import { render } from "./opinion-bar-vuex.vue?vue&type=template&id=604bafd2"
import script from "./opinion-bar-vuex.vue?vue&type=script&lang=js"
export * from "./opinion-bar-vuex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__